module.exports = __webpack_public_path__ + "img/logo-pln.6e18a382.png";